class Convert {


    constructor() {
    }

    static B2GB(byte) {
        if (byte === null) {
            byte = 0;
        }

        if (byte / Math.pow(1024, 3) > 1)
            return (byte / Math.pow(1024, 3)).toFixed(1) + 'GB';
        if (byte / Math.pow(1024, 2) > 1)
            return (byte / Math.pow(1024, 2)).toFixed(1) + 'MB';
        else if (byte / Math.pow(1024, 1) > 1)
            return (byte / Math.pow(1024, 1)).toFixed(1) + 'KB';
        else
            return byte + 'B';
    }
	
	static milliSecond2seconds = (ms) => {
		return ms / 1000;
	}

}

export default Convert;